export default {"src":"https://cdn.jetlend.ru/_next/static/media/reports--card-background.56457fa1.svg","height":432,"width":760,"blurWidth":0,"blurHeight":0};